// src/pages/Validation.js
import React, { useState, useEffect } from 'react';
import customers from './conf/Customers';
import CustomerStyles from './conf/CustomerStyles';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { writeLogMsg } from './conf/log';

function Validation() {
    writeLogMsg('Validation page');
      const [selectedCustomer, setSelectedCustomer] = useState(customers.shortlist.find(item => item.id.toString() === localStorage.getItem('customer')) || customers.shortlist.find(item => item.label === global.APP_DEFAULT_CUSTOMER) || customers.shortlist[0]);
    CustomerStyles(selectedCustomer);
    const { t } = useTranslation();
    const navigation = useNavigate();
    const location = useLocation();
    const {state} = location;
        
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        // Vérifiez si l'état de l'expédition est présent
        if (state && state.shipment) {
        } else {
            writeLogMsg('Validation: No shipment found, redirecting to Home');
            navigation("/");
        }
    }, [state, navigation]); // Dépendances pour re-exécuter l'effet si l'état change


    const handleValidation = () => {
        validate();
    };

    useEffect(() => {
        const handle = () => validate();

        window.addEventListener("app-back", handle);
        return () => window.removeEventListener("app-back", handle);
    }, [navigation]);

    const validate = () => {
        // Return Home with reset of the state of the navigation
        navigation("/");
    };

  useEffect(() => {
    const handleOnline = async () => {
      setIsOnline(true);
      writeLogMsg('Validation: handleOnline: Vous êtes en ligne !');

      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'P4C_SYNC_ONLINE' });
        writeLogMsg('Validation: handleOnline: Envoi du message de synchronisation au service worker');
      } else {
        writeLogMsg('Validation: handleOnline: Service worker non disponible ou pas contrôleur actif');
      }

    };

    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('online', handleOnline);
    };
  }, []);

    return (
        <div id="mainDiv" style={{position : 'static'}} >
            <div>
                {/* Navigation bar */}
                <nav className="navbar navbar-expand-lg navbar-fixed-top navbar-default col-sm-12" role="navigation" style={{ display: 'flow-root' }}>
                    <span className="navbar-brand col-sm-12" style={{ textAlign: 'center' }}/>
                </nav>

                {/* Comfirmation message */}
                <div className="col-sm-10 col-lg-8 mx-auto">
                    {/* Customer logo */}
                    <div className="form-group">
                        {selectedCustomer && selectedCustomer.name && (
                        <img
                            src={`assets/images/xhdpi/logo-${selectedCustomer.name}.png`}
                            srcSet={`assets/images/mdpi/logo-${selectedCustomer.name}.png 320w,
                                    assets/images/hdpi/logo-${selectedCustomer.name}.png 480w,
                                    assets/images/xhdpi/logo-${selectedCustomer.name}.png 640w,
                                    assets/images/xxhdpi/logo-${selectedCustomer.name}.png 960w`}
                            alt={`Logo ${selectedCustomer.name}`}
                            className="img-responsive logo_center_img"
                        />
                        )}
                    </div>        
                    {/* Collect button */}
                    <div className="jumbotron form-group">
                        <span>{t('MSG_SAVE_SUCCESS')}</span>
                    </div>
                    {/* Delivery button */}
                    <div className="text-center">
                        <button id="btnValidation" onClick={handleValidation} className="btn btn-default btn-large btn-block">
                            <span>{t('BTN_HOME')}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Validation;